import { render, staticRenderFns } from "./writingIcon.vue?vue&type=template&id=ba210b1e&scoped=true"
import script from "./writingIcon.vue?vue&type=script&lang=js"
export * from "./writingIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba210b1e",
  null
  
)

export default component.exports